import Page, { background } from "./page";

import { ReplicaItemType } from "types";
import thumbnail from "./gallery/promo-you-know-who_00.jpg";

const data: ReplicaItemType = {
  id: "the-quibbler-v1-you-know-who-claims-grade-b",
  name: "The Quibbler v1 - You-Know-Who Claims Another Victim (Grade B)",
  nameFormatted: {
    primary: "Grade B",
    secondary: "The Quibbler v1",
    tertiary: "You-Know-Who Claims Another Victim",
  },
  page: <Page />,
  thumbnail,
  background,
};

export default data;
